import { getErrorMsgAndCode } from "./FrontendHelpers";
import api from "./axios";

export async function GetEmployees() {
  try {
    const response = await api.get("/getEmployees");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForEmployee() {
  try {
    const response = await api.get("/checkForEmployee");
    const result = response.data;

    return [result.exists, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function AcceptEmployeeRequest(MessageID) {
  try {
    const data = { MessageID };

    const response = await api.post("/acceptEmployeeRequest", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetEmployeeData(ID) {
  try {
    const data = { ID };

    const response = await api.post("/getEmployeeInfo", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function EditEmployeeData(EmployeeID, RoleID) {
  try {
    const data = { EmployeeID, RoleID };

    const response = await api.post("/editEmployeeData", data);
    const result = response.data;
    console.log("updated role in helpes", result);

    return [result, null];
  } catch (error) {
    console.log("error in helpes", error);

    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function RemoveEmployee(EmployeeID) {
  try {
    const data = { EmployeeID };

    const response = await api.post("/removeEmployee", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
